<template>
  <div
    class="article-Detail"
  >
    <template v-if="artContent.contentId">
      <breadcrumb :crumb="crumb" />
      <articleContent
        :show-title="true"
        :art-content="artContent"
      />
      <timeStatistics :content-id="this.contentId" />
    </template>
  </div>
</template>

<script>
import api from '../../proxy';
import breadcrumb from '../components/breadcrumb';
import articleContent from '../components/articleContent';
import timeStatistics from '../components/timeStatistics';
export default {
    name: 'ArticleDetail',
    components: {
        breadcrumb,
        articleContent,
        timeStatistics,
    },
    data () {
        return {
            artContent: {},
        };
    },
    computed: {
        crumb () {
            const query = this.$route.query;
            const result = {
                catalogId: query.currCatalogId,
            };
            return result;
        },
        contentId () {
            let result = this.$route.query.contentId;
            if (result) {
                return result;
            }
            if (this.artContent.contentId) {
                return this.artContent.contentId;
            }
            return '';
        },
    },
    async created () {
        const { contentId } = this.$route.query;
        const res = await api.contentDetail({ contentId });
        if (res.errcode === 0) {
            this.artContent = res.data;
        } else {
            this.$message.error(res.errmsg);
        }
    },
};
</script>

<style scoped lang="scss">
@import "../style.scss";
.article-Detail {
    width: $pageWidth;
    margin: 0 auto;
    padding: 40px 0;
    min-height: calc(100vh - 200px);
    box-sizing: border-box;
}
</style>
